<div class="container-fuild">
  <div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
    <div class="row">
      <div class="col-lg-5">
        <div
          class="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent"
        >
          <div>
            <img src="../../../../assets/img/bg/authentication-bg-04.svg" alt="Img" />
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-12 col-sm-12">
        <div class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
          <div class="col-md-7 mx-auto vh-100">
            <div class="clearfix"></div>
            <form [formGroup]="form" class="vh-100">
              <div class="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                <div class="mx-auto mb-5 text-center">
                  <img src="../../../../assets/img/logo/logo.webp" class="img-fluid" alt="Logo" />
                </div>
                <div class="">
                  <div class="text-center mb-3">
                    <h2 class="mb-2">Forgot Password?</h2>
                    <p class="mb-0">
                      If you forgot your password, well, then we'll email you instructions to reset
                      your password.
                    </p>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="email">Email Address</label>
                    <div class="input-group">
                      <input
                        appTrimInput
                        type="email"
                        value=""
                        formControlName="email"
                        class="form-control border-end-0"
                        appTrimInput
                        appStrictEmail
                      />
                      <span class="input-group-text border-start-0">
                        <i class="ti ti-mail"></i>
                      </span>
                    </div>
                    <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('email') }}
                      </span>
                    </div>
                  </div>
                  <div class="mb-3">
                    <button
                      type="submit"
                      class="btn btn-primary w-100"
                      [disabled]="form.invalid"
                      (click)="reset()"
                    >
                      <ng-container *ngIf="isLoading$ | async; else loading">
                        <span
                          class="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submit...
                      </ng-container>
                      <ng-template #loading> Submit </ng-template>
                    </button>
                  </div>
                  <div class="text-center">
                    <h6 class="fw-normal text-dark mb-0">
                      Return to
                      <a [routerLink]="eps.auth.loginPath" class="hover-a">Sign In</a>
                    </h6>
                  </div>
                </div>
                <div class="mt-5 pb-4 text-center">
                  <p class="mb-0 textt-gray-9" id="copyright" [innerHTML]="copyrightText"></p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
